<template>
    <div :class="['container ub ub-ver', { 'container-dark': theme_dark }]">
      <div class="nav-top">
            <div class="nav-left" @click="back()">
              <img src="../../assets/img/返回箭头.png" class="nav-img" />
              <span class="nav-lable"></span>
            </div>
            <div class="nav-middle">修改背景</div>
            <div class="nav-right"  @click="goto_custom_bg_img()">
              <span class="nav-lable none">自定义</span>
              <img src="../../assets/img/返回箭头.png" class="nav-img none" />
            </div>
        </div>

       <div class="bg-pic" :style="{ 'background-image': 'url(' + pic_back + ')'}"></div>
  
      <div class="pic-img-block">
        <div class="ub ub-pc ub-ac1 flexWrap">
          <img  v-for="(item,index) in ary_pic" :key="index" :src="['http://appdata.jscx666.cn/photo/bg_img/' + item + '.jpg']" :class="chosed==item ? 'on' : ''" @click="chose('http://appdata.jscx666.cn/photo/bg_img/' + item + '.jpg',item)"/>
        </div>

        <div class="ub ub-ac ub-pc load" @click="load_more()">
            <span>加载更多</span>
        </div>
        
      </div>
      <div class="ub ub-pc ub-ac">
        <div class="btn ub ub-pc ub-ac" @click="save()"><span>完成</span></div>
      </div>
      
      
    </div>
  </template>
  
  <script>
  import * as tool from "../../api/common";
  import { mapMutations, mapActions } from "vuex";
  
  export default {
    data() {
      return {
        data: "",
        pic_back:"",
        ary_pic:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18],
        chosed:0,
        theme_dark: false
      };
    },
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      this.init_page();
    },
    methods: {
      ...mapMutations(["get", "post", "post2"]), //引入方法
      ...mapActions(["act_reload_userinfo","act_get_userinfo"]), //引入方法
      back() {
        this.$router.go(-1); //返回上一层
      },
      goto_custom_bg_img(){
        this.$router.push({ name: "custom_bg_img" });
      },
  
      chose(url,item){
        
          //console.log(url);
          this.pic_back=url;
          this.chosed=item;
          //console.log("第"+item+"张图片");
         // console.log("chosed的值为"+this.chosed);
      },
      load_more(){
        var length = this.ary_pic.length;
        if(this.ary_pic.length<63){
          for(var i=1;i<=9;i++){
            this.ary_pic.push(this.ary_pic.length+1)
        }
        }else{
           this.$toast.center("没有更多了~");
        }
       
      },
       init_page() {
        var uid = this.$store.state.uid;
        var self = this;
  
        self.act_get_userinfo({
          uid: uid,
          success: function (u) {
            //console.log(JSON.stringify(u));
            self.pic_back = u.pic_back;
  
            if(self.pic_back ==""){
               self.pic_back="http://appdata.jscx666.cn/photo/bg_img/1.jpg";
            }
            
          },
        });
      },
      save() {
        //后台保存信息
          var self = this;
          var uid = this.$store.state.uid;
          var pic_back = this.pic_back;
          console.log(pic_back);
  
          var send_data = {"pic_back":pic_back };
          var data = {
            url: "/App/User_ModifyBaseInfo",
            data: {
              uid: uid,
              data: JSON.stringify(send_data),
            },
            success: function (data_serve) {
              if (data_serve.state == "1") {
                self.act_reload_userinfo({
                  uid: uid,
                  success: function (info) {
                    self.back();
                  },
                });
              }
            },
          };
          self.post(data);
          
      },
    },
   
    
  };
  </script>
  
  <style lang="scss" scoped>
  .container {
    height: 100vh;
    background-color: #EFEFEF;
  } 

  .nav-top {
    width: 100%;
    position: fixed;
    background-color: transparent;
  }

  .bg-pic {
    margin-top: -2.6rem;
    height: 16rem;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  

  .pic-img-block{
    padding: 1rem;
    margin-top: -1rem;
    flex: 1;
    overflow-y: auto;
    background-color: #FDFDFD;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    img{
        width: 5.5rem;
        height: 4rem;
        margin-right: 1rem;
        margin-bottom: 1.5rem;
        border-radius: 0.5rem;
    }
    .load {
        span {
            color: #BA61FF;
            font-size: 0.75rem;
        }
    }
    .on {
        padding: 0.3rem;
        border: 2px solid;
        border-image: linear-gradient(86deg, rgba(162, 100, 231, 1), rgba(254, 156, 192, 1)) 2 2;
        img {
          width: 5.2rem;
          height: 3.7rem;
        }
    }
  }
  .btn {
    padding: 0.5rem 8rem;
    margin: 1rem;
    color: #fff;
    font-size: 0.9rem;
    border-radius: 1rem;
    background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
  }
  
  .container-dark {
    background-color: #2f2e33;
    .pic-img-block {
      background-color: #2f2e33;
    }
  }
  </style>